import React, { useEffect, useState } from 'react';
import { DatePicker, Loader } from 'rsuite';
import { Card } from './card.component';
import upSolidIcon from '../assets/img/header-chevron-up-solid.svg';
import downSolidIcon from '../assets/img/header-chevron-up-solid.svg';
import { useHistory } from 'react-router-dom';
import { SearchQueryParams } from '../config/constants';
import { EnumInvoiceStatus } from '../libs';
import { AppRouteUi } from '../config/appRoute';
import { GetAppointmentCountWithPendingInvoice } from '../core/apis/reporting';
import { StorageAuth } from '../core/localStorage';
import { Button } from './button.component';
import { UtilityDate } from '../utils/dateUtils';

function MissingInvoiceReportComponent() {
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [missingInvoiceCount, setMissingInvoiceCount] = useState<number>();
  const [isBusy, setIsBusy] = useState(false);

  const isValidStartDate = (date?: Date) => {
    if (!date) return false;
    if (!endDate) return true;
    if (date <= endDate) return true;
    return false;
  };

  const isValidEndDate = (date?: Date) => {
    if (!date) return false;
    if (!startDate) return true;
    if (date >= startDate) return true;
    return false;
  };

  const fetchReferrals = () => {
    setIsBusy(true);
    let startDateWithTime: Date | undefined;
    let endDateWithTime: Date | undefined;
    if (startDate) {
      startDateWithTime = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate()
      );
    }
    if (endDate) {
      endDateWithTime = new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate(),
        23,
        59,
        59
      );
    }
    GetAppointmentCountWithPendingInvoice({
      fromDate: startDateWithTime?.toISOString(),
      toDate: endDateWithTime?.toISOString(),
      companyId: StorageAuth.CompanyId!,
    }).then((res) => {
      setIsBusy(false);
      if (res.data.data) {
        setMissingInvoiceCount(res.data.data?.count);
      }
    });
  };

  const history = useHistory();

  const handleClick = () => {
    if (missingInvoiceCount) {
      let searchStr = `${SearchQueryParams.InvoiceStatus}=${EnumInvoiceStatus.MissingInvoice}`;
      if (startDate) {
        searchStr += `&${
          SearchQueryParams.FromDate
        }=${startDate.toISOString()}`;
      }
      if (endDate) {
        searchStr += `&${SearchQueryParams.ToDate}=${endDate.toISOString()}`;
      }
      history.push({
        pathname: AppRouteUi.Invoice.List(),
        search: searchStr,
      });
    }
  };

  useEffect(() => {
    const startOfMonth = UtilityDate.getStartOfPreviousMonth();
    const endOfMonth = UtilityDate.getEndOfPreviousMonth();
    setIsBusy(true);
    GetAppointmentCountWithPendingInvoice({
      fromDate: startOfMonth.toISOString(),
      toDate: endOfMonth.toISOString(),
      companyId: StorageAuth.CompanyId!,
    }).then((res) => {
      setIsBusy(false);
      if (res.data.data) {
        setMissingInvoiceCount(res.data?.data.count);
      }
    });
    setStartDate(startOfMonth);
    setEndDate(endOfMonth);
  }, []);

  return (
    <Card
      header={
        <div className="row align-items-center  justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div>
              <p className="text-capitalize my-1 text-green-200">
                Missing invoices
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
          <a
            className="btn  box-collapse-btn me-1"
            data-bs-toggle="collapse"
            href="#missing_invoice"
            role="button"
            aria-expanded="false"
            aria-controls="missing_invoice"
          >
            <img
              src={upSolidIcon}
              alt="up"
              className="img-fluid svg-btn collapse-close"
            />
            <img
              src={downSolidIcon}
              alt="down"
              className="img-fluid svg-btn collapse-open"
            />
          </a>
        </div>
      }
      className='h-100'
    >
      <div id="missing_invoice" className="container pt-1 pb-5">
        <div className="row g-0 align-items-center">
          <div className="col-auto">
            <span className="pe-1">Start Date</span>
          </div>
          <div className="col-3">
            {/* <DateInput name="startDate">Start Date</DateInput> */}
            <DatePicker
              disabledDate={(date?: Date) => !isValidStartDate(date)}
              onChange={setStartDate}
              value={startDate}
              format="MM-dd-yyyy"
            />
          </div>

          <div className="col-auto ps-2">
            <span className="pe-1">End Date</span>
          </div>

          <div className="col-3">
            <DatePicker
              disabledDate={(date?: Date) => !isValidEndDate(date)}
              onChange={setEndDate}
              value={endDate}
              format="MM-dd-yyyy"
            />
          </div>

          <div className="col-auto ps-2">
            <Button
              name="Search"
              className="btn-green"
              onClick={fetchReferrals}
            />
          </div>
        </div>
        <div className="row g-0 align-items-center pt-3">
          <div className="col-12 text-center">
            {!!missingInvoiceCount && !isBusy && (
              <span
                className={`text-success ${
                  missingInvoiceCount ? 'click text-underline' : ''
                }`}
                onClick={handleClick}
              >
                Total: {missingInvoiceCount}
              </span>
            )}
            {isBusy && <Loader size="sm" />}
          </div>
        </div>

        <div className="py-5" />
        <div className="py-5" />
      </div>
    </Card>
  );
}

export const MissingInvoiceReport = React.memo(MissingInvoiceReportComponent);
